import { UniDriver } from '@wix/unidriver-core';
import { baseModalLayoutDriverFactory } from '../BaseModalLayout/BaseModalLayout.uni.driver';

export const customModalLayoutDriverFactory = (
  base: UniDriver,
  body?: UniDriver,
) => {
  return {
    ...baseModalLayoutDriverFactory(base, body),
    /**
     * Checks whether the modal content has padding
     * @returns {Promise<boolean>}
     * */
    hasContentPadding: async (): Promise<boolean> =>
      (await base.attr('data-contentpadding')) === 'true',
  };
};

export type CustomModalLayoutUniDriver = ReturnType<
  typeof customModalLayoutDriverFactory
>;
